






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class StatusBadge extends Vue {
	@Prop()
	public status!: string;

	get statusClass(): string {
		switch (this.status) {
			case 'new':
				return 'badge-primary';
			case 'confirmed':
				return 'badge-success';
			case 'deleted':
				return 'badge-danger';
			default:
				return '';
		}
	}

	get statusTranslation(): string {
		switch (this.status) {
			case 'new':
				return 'Neu';
			case 'confirmed':
				return 'Bestätigt';
			case 'deleted':
				return 'Storniert';
			default:
				return this.status;
		}
	}
}
